var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "nav",
    {
      ref: "navbar",
      class: "jp-navbar  jp-navbar--" + _vm.navbarLayoutType,
      style:
        _vm.env == "test"
          ? "background:#ff0000"
          : _vm.env == "development"
          ? "background:#0bbd87"
          : "background:" + _vm.defaultTheme,
    },
    [
      _c("div", { staticClass: "jp-navbar__header" }, [
        _c(
          "h1",
          {
            staticClass: "jp-navbar__brand",
            on: {
              click: function ($event) {
                return _vm.$router.push({ name: "home" })
              },
            },
          },
          [
            _c(
              "a",
              {
                staticClass: "jp-navbar__brand-lg",
                attrs: { href: "javascript:;" },
              },
              [
                _c("img", {
                  attrs: {
                    src: require("../../assets/img/unitLogo.png"),
                    height: "40px",
                    width: "40px",
                  },
                }),
                _vm._v(" " + _vm._s(_vm.productName) + " "),
                _vm.env == "test" ? [_vm._v("(!!!测试版!!!)")] : _vm._e(),
                _vm._v(" "),
                _vm.env == "development"
                  ? [_vm._v("(!!!开发版!!!)")]
                  : _vm._e(),
              ],
              2
            ),
            _vm._m(0),
          ]
        ),
      ]),
      _c(
        "div",
        {
          staticClass: "jp-navbar__body clearfix",
          staticStyle: { overflow: "hidden" },
        },
        [
          _c(
            "el-menu",
            { staticClass: "jp-navbar__menu", attrs: { mode: "horizontal" } },
            [
              _c(
                "el-menu-item",
                {
                  staticClass: "jp-navbar__switch",
                  on: {
                    click: function ($event) {
                      _vm.sidebarFold = !_vm.sidebarFold
                    },
                  },
                },
                [
                  _c("i", {
                    class: _vm.sidebarFold ? "fa fa-indent" : "fa fa-outdent",
                  }),
                ]
              ),
            ],
            1
          ),
          _c(
            "el-menu",
            {
              ref: "topMenu",
              staticClass: "jp-navbar__menu ",
              attrs: {
                "default-active": _vm.topMenuActiveIndex,
                mode: "horizontal",
              },
            },
            [
              _vm._l(_vm.topMenuList, function (menu) {
                return _c(
                  "el-menu-item",
                  {
                    key: menu.id,
                    ref: menu.id,
                    refInFor: true,
                    staticClass: "el_menu_item",
                    attrs: { index: menu.id, menu: menu },
                    on: {
                      click: function ($event) {
                        return _vm.showLeftMenu(menu)
                      },
                    },
                  },
                  [
                    _c("i", {
                      class: menu.icon + " jp-sidebar__menu-icon",
                      staticStyle: { display: "inline-block!important" },
                    }),
                    _vm._v(" " + _vm._s(menu.name) + " "),
                  ]
                )
              }),
              _vm.topHideMenuList.length != 0
                ? _c(
                    "el-submenu",
                    { attrs: { index: "2" } },
                    [
                      _c("template", { slot: "title" }, [_vm._v("更多")]),
                      _vm._l(_vm.topHideMenuList, function (menu) {
                        return _c(
                          "el-menu-item",
                          {
                            key: menu.id,
                            ref: menu.id,
                            refInFor: true,
                            attrs: { index: menu.id, menu: menu },
                            on: {
                              click: function ($event) {
                                return _vm.showLeftMenu(menu)
                              },
                            },
                          },
                          [
                            _c("i", {
                              class: menu.icon + " jp-sidebar__menu-icon",
                              staticStyle: {
                                display: "inline-block!important",
                              },
                            }),
                            _vm._v(" " + _vm._s(menu.name) + " "),
                          ]
                        )
                      }),
                    ],
                    2
                  )
                : _vm._e(),
            ],
            2
          ),
          _c(
            "el-menu",
            {
              staticClass: "jp-navbar__menu jp-navbar__menu--right",
              attrs: { mode: "horizontal" },
            },
            [
              _c(
                "el-menu-item",
                { staticClass: "hide-sm" },
                [_c("template", { slot: "title" }, [_c("color-picker")], 1)],
                2
              ),
              _c(
                "el-menu-item",
                { staticClass: "hide-sm" },
                [
                  _c(
                    "template",
                    { slot: "title" },
                    [
                      _c("notice-icon", {
                        staticClass: "action notice",
                        attrs: { tabs: _vm.noticeTabs },
                      }),
                    ],
                    1
                  ),
                ],
                2
              ),
              _c(
                "el-menu-item",
                { staticClass: "jp-navbar__avatar" },
                [
                  _c(
                    "el-dropdown",
                    { attrs: { "show-timeout": 0, placement: "bottom" } },
                    [
                      _c("span", { staticClass: "el-dropdown-link" }, [
                        _c("img", {
                          staticClass: "hide-sm",
                          attrs: {
                            src:
                              _vm.photo === ""
                                ? "/static/img/avatar.png"
                                : _vm.photo,
                          },
                        }),
                        _vm._v(_vm._s(_vm.userName) + " "),
                      ]),
                      _c(
                        "el-dropdown-menu",
                        { attrs: { slot: "dropdown" }, slot: "dropdown" },
                        [
                          _c(
                            "el-dropdown-item",
                            {
                              nativeOn: {
                                click: function ($event) {
                                  return _vm.updatePasswordHandle()
                                },
                              },
                            },
                            [_vm._v("修改密码")]
                          ),
                          _c(
                            "el-dropdown-item",
                            {
                              nativeOn: {
                                click: function ($event) {
                                  return _vm.logoutHandle()
                                },
                              },
                            },
                            [_vm._v("退出")]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-menu-item",
                { staticClass: "hide-sm", on: { click: _vm.showRight } },
                [
                  _c("template", { slot: "title" }, [
                    _c("i", {
                      staticClass: "el-icon-more rotate-90",
                      on: { click: _vm.showRight },
                    }),
                  ]),
                ],
                2
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm.updatePassowrdVisible
        ? _c("update-password", { ref: "updatePassowrd" })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "a",
      { staticClass: "jp-navbar__brand-mini", attrs: { href: "javascript:;" } },
      [
        _c("img", {
          attrs: {
            src: require("../../assets/img/unitLogo.png"),
            height: "40px",
            width: "40px",
          },
        }),
      ]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }